import { isNativeApp } from './platform'
import { hydrateInstance } from './instance'
import { hydrateCredentials } from './credentialStore'
import { hydratePublicConfig, loadPublicConfig } from '../runtimeConfig'

/**
 * Native B1 start-up: load the persisted instance, then that instance's credentials, then its
 * cached public config, so the sync readers (`getInstance`, `apiBaseUrl`, `getCredential`,
 * `getMapTileSettings`) are ready before the first request. Order matters — credentials and
 * the config cache are namespaced by the instance host. The config is then refreshed from the
 * server in the background: first render never waits on the network (offline keeps the cache).
 * No-op on web.
 */
export async function bootstrapNative(): Promise<void> {
  if (!isNativeApp()) return
  await hydrateInstance()
  await hydrateCredentials()
  await hydratePublicConfig()
  void loadPublicConfig()
}
